import { gql } from 'apollo-angular';

export const ACCOUNT_PROFILE_IMAGE_FRAGMENT = gql`
  fragment AccountProfileImageFragment on Account {
    id
    profile {
      imageUrls {
        download
        upload
      }
    }
  }
`;
